/**
 * Transcription Queue - Fault-tolerant audio chunk delivery
 *
 * This module provides a persistent queue for transcription chunks that:
 * - Survives browser refresh/crash (IndexedDB + localStorage)
 * - Automatically retries failed chunks with exponential backoff
 * - Isolates errors so one failure doesn't block others
 * - Processes chunks in order within each session
 *
 * Usage:
 * 1. Call useTranscriptionQueue.getState().setProcessFn() to set the processor
 * 2. Call useTranscriptionQueue.getState().initializeFromStorage() on mount
 * 3. Call useTranscriptionQueue.getState().enqueue() for each chunk
 * 4. The queue handles processing, retries, and cleanup automatically
 */

/**
 * Returns a timestamp string for logging: HH:MM:SS.mmm
 */
export function logTimestamp(): string {
  const now = new Date();
  const h = now.getHours().toString().padStart(2, "0");
  const m = now.getMinutes().toString().padStart(2, "0");
  const s = now.getSeconds().toString().padStart(2, "0");
  const ms = now.getMilliseconds().toString().padStart(3, "0");
  return `${h}:${m}:${s}.${ms}`;
}

export * from "./types";
export * from "./idb";
export * from "./processor";
